import React from 'react'
import '../../assets/landingPageCss/common.css';
import '../../assets/landingPageCss/style.css';
import '../../assets/landingPageCss/bookDemo.css';
import LottiePlayer from './LottiePlayer';
import logoTransparentPng from '../../assets/images/landing/logoTransparent.png';
import { Link } from 'react-router-dom';
import Footer from './Footer';
import Navbar from './Navbar';

function DemoConfirmation() {
  return (
    <main className='untitled-page mainContent'>
      <Navbar />
      <section className='bookDemoSection'>
        <div class="bookDemoWrapper">
          <div class="bookDemoConfirmationContainer">
            <LottiePlayer src={'./landing/bookDemoConfirmation.json'} style={{ width: '250px', margin: '30px 0px' }} interactivity={false} />
            {/* <lottie-player src="assets/lotties/bookDemoConfirmation.json"  background="transparent" speed="1" loop autoplay ></lottie-player> */}
            <h1 class="bookTitle">Thank You for <br /><span class="underline">Booking a Demo!</span></h1>
            <p class="bookText">We’re excited to show you how Adcropper can transform your ad creation and campaign management.</p>
            <div class="bookList">
              <h1>
                What happens next?<br /><br />
                One of our team members will reach out shortly to confirm the details and schedule your personalized demo.<br /><br />
                In the meantime, feel free to explore more about our platform and how we’re helping businesses like yours stay ahead of the competition.<br /><br />
              </h1>
            </div>
            <Link to={'/home'} className='featureButton'>EXPLORE MORE</Link>
          </div>

        </div>
        <img class="heroImage user-select-none" src={logoTransparentPng} draggable="false"
          alt="Adcropper Logo Transparent" />
      </section>
      <Footer showBookDemo={false} />
    </main>
  )
}

export default DemoConfirmation;